import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  Paper,
} from '@mui/material';
import {
  EventSeat,
  People,
  TrendingUp,
  CheckCircle,
  WhatsApp,
  Phone,
  DirectionsWalk,
} from '@mui/icons-material';
import Sidebar from '../components/Sidebar';
import api from '../services/api';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
  LineChart,
  Line,
} from 'recharts';
import moment from 'moment';
import StatsDashboard from "./StatsDashboard";  // path where you saved it
import dayjs from 'dayjs';
const AdminDashboard = () => {
  const [tables, setTables] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
    const [Stats, setStats] = useState([]);


  useEffect(() => {
    fetchData();
    fetchStats()
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/customers/stats/overview');
      setStats(response.data);
      console.log(response.data,"response.data")
    } catch {
      console.error('Failed to fetch stats');
    }
  };
  
  const fetchData = async () => {
    try {
      const [tablesRes, bookingsRes] = await Promise.all([
        api.get('/tables'),
        api.get('/bookings'),

      ]);
      setTables(tablesRes.data);
 
      const today = dayjs().startOf("day");

// Filter only today’s bookings
const todaysBookings = bookingsRes.data.filter((b) =>
  dayjs(b.date).isSame(today, "day")
);
     setBookings(todaysBookings);
      console.log(todaysBookings)
    } catch (err) {
      console.error(err);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const stats = {
    totalTables: tables.length,
    availableTables: tables.filter(t => t.isAvailable).length,
    totalBookings: bookings.length,
    pendingBookings: bookings.filter(b => b.status === 'pending').length,
    confirmedBookings: bookings.filter(b => b.status === 'confirmed').length,
  };

  const chartData = [
    { name: 'Confirmed', value: stats.confirmedBookings },
    { name: 'Pending', value: stats.pendingBookings },
  ];

  // Line chart data: count bookings per day
  const lineChartData = bookings.reduce((acc, booking) => {
    const date = moment(booking.date).format('YYYY-MM-DD');
    const existing = acc.find(item => item.date === date);
    if (existing) {
      existing.count += 1;
    } else {
      acc.push({ date, count: 1 });
    }
    return acc;
  }, []).sort((a, b) => new Date(a.date) - new Date(b.date));

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}


 <div style={{ padding: 20 }}>
{Stats?.length > 0 && <StatsDashboard data={Stats} />}
      
    </div>
        {/* Dashboard Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #1976d2', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <EventSeat sx={{ mr: 2, color: 'primary.main', fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5">{stats.totalTables}</Typography>
                    <Typography color="text.secondary">Total Tables</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #2e7d32', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <CheckCircle sx={{ mr: 2, color: 'success.main', fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5">{Stats.activeCustomers}</Typography>
                    <Typography color="text.secondary">Total customer</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
           <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #2e7d32', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <CheckCircle sx={{ mr: 2, color: 'success.main', fontSize: 40 }} />
                  <Box>
       <Typography color="text.secondary">New Customers (This Month)</Typography>
<Typography variant="h5">
  {Stats?.monthlyCustomers?.[0]?.count ?? 0}
</Typography>
{/* <Typography color="text.secondary">
  {Stats?.monthlyCustomers?.[0]?.month ?? "N/A"}
</Typography> */}


                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
   
               <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #2e7d32', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <WhatsApp sx={{ mr: 2, color: 'success.main', fontSize: 40 }} />
                  <Box>
                 
                    <Typography variant="h5">  {Stats?.sourceBreakdown?.whatsapp ?? 0}
</Typography>
                    <Typography color="text.secondary">WhatsApp customer</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
         
               <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #2e7d32', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <Phone sx={{ mr: 2, color: 'success.main', fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5">{Stats?.sourceBreakdown?.phone ?? 0}</Typography>
                    <Typography color="text.secondary">Phone customer</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
               <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #2e7d32', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <DirectionsWalk sx={{ mr: 2, color: 'success.main', fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5">{Stats?.sourceBreakdown?.walkIn ?? 0}</Typography>
                    <Typography color="text.secondary">walkIn customer</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderLeft: '5px solid #9c27b0', borderRadius: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  <People sx={{ mr: 2, color: 'secondary.main', fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5">{stats.totalBookings}</Typography>
                    <Typography color="text.secondary">Total Bookings</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
   
        </Grid>
<Grid container spacing={2}>
  <Grid size={6}>

  <Grid item xs={12} md={6}>
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, height: "100%" }}>
      <Typography variant="h6" mb={2}>
        Booking Status Chart (Today)
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="value" fill="#42a5f5" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  </Grid>
  </Grid>
  <Grid size={6}>
  <Grid item xs={12} md={6}>
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, height: "100%" }}>
      <Typography variant="h6" mb={2}>
        Daily Bookings Trend
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={lineChartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="count" stroke="#66bb6a" />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  </Grid>
 </Grid>
  </Grid>
{/* </Grid> */}

      </Box>
    </Box>
  );
};

export default AdminDashboard;
